import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, Info, Newspaper } from "lucide-react";
import { SITE } from "../mock";

export default function AboutPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-amber-300">
        <ArrowLeft className="w-4 h-4" /> Back to Home
      </Link>
      <h1 className="mt-4 text-3xl md:text-4xl font-bold text-slate-100">About {SITE.name}</h1>
      <p className="mt-3 text-slate-400 leading-relaxed">
        {SITE.name} ek informational platform hai jahan users daily Madhur Lottery aur Starline ke updates
        check kar sakte hain. Hum koi betting, gambling ya monetary service offer nahi karte.
      </p>

      <div className="mt-8 grid sm:grid-cols-3 gap-4">
        {[
          { icon: Newspaper, title: "Daily Updates", desc: "Regular result archive ke saath time-wise records." },
          { icon: ShieldCheck, title: "Informational Only", desc: "Yahan information sirf public records par based hai." },
          { icon: Info, title: "Transparent", desc: "Date, time aur number har record me clearly diya hai." },
        ].map((c, i) => (
          <div key={i} className="rounded-xl border border-white/5 bg-[#11172a] p-5">
            <c.icon className="w-5 h-5 text-amber-300" />
            <div className="mt-3 text-slate-100 font-semibold">{c.title}</div>
            <div className="mt-1 text-sm text-slate-400">{c.desc}</div>
          </div>
        ))}
      </div>

      <div className="mt-10 p-6 rounded-2xl border border-amber-400/15 bg-amber-950/20">
        <div className="text-amber-300 text-xs uppercase tracking-[0.2em] font-semibold">Disclaimer</div>
        <p className="mt-2 text-slate-300 text-sm leading-relaxed">
          Yeh website sirf informational purposes ke liye banayi gayi hai. Hum kisi bhi tarah ki gambling ya
          betting ko promote nahi karte. Yahan dikhaya gaya data internet par available public records par
          aadharit hai. Kripya apne vivek aur niyam-kanoon ke anusar is information ka use karein.
        </p>
      </div>
    </div>
  );
}
